export const customIconData = [
  'custom-icon-statistics-filled',
  'custom-icon-accounts-filled',
  'custom-icon-task-filled',
  'custom-icon-project-filled',
  'custom-icon-cloud-account-filled',
  'custom-icon-schedule-filled',
  'custom-icon-home-filled',
  'custom-icon-config-center-filled',
  'custom-icon-partner-filled',
  'custom-icon-asset-filled',
  'custom-icon-delivery-filled',
  'icon-business-modeling|svg',
  'icon-product-library|svg',
];
